var ActiveFootnoteHighlight, ContextMenuView, HelpBoxView, OutcomeEditRowView, OutcomeScaleTypes, QualityIndicatorsInput, ReactComponent, Shortcuts, SortOutcomesView, TimeToEventModal, Validation, View, W, WysiwygFootnotes, calculateThreshold, mediator, utils,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ActiveFootnoteHighlight = require('lib/traits/active_footnote_highlight');

ContextMenuView = require('views/evidence_syntheses/context_menu_view');

HelpBoxView = require('views/help_box_view');

mediator = require('mediator');

calculateThreshold = require('lib/outcomes_helper').calculateThreshold;

OutcomeScaleTypes = require('lib/traits/outcome_scale_types');

QualityIndicatorsInput = require('components/quality_indicators/quality_indicators_input');

Shortcuts = require('base/lib/traits/shortcuts');

SortOutcomesView = require('views/evidence_syntheses/sort_outcomes_view');

TimeToEventModal = require('views/evidence_syntheses/time_to_event_modal');

utils = require('base/lib/utils');

ReactComponent = require('base/lib/traits/react_component');

Validation = require('base/validation');

View = require('base/views/view');

W = require('when/when');

WysiwygFootnotes = require('lib/traits/wysiwyg_footnotes');

module.exports = OutcomeEditRowView = (function(_super) {
  __extends(OutcomeEditRowView, _super);

  function OutcomeEditRowView() {
    this.deleteOutcome = __bind(this.deleteOutcome, this);
    this.render = __bind(this.render, this);
    this._deleteCurrentOutcomeEditView = __bind(this._deleteCurrentOutcomeEditView, this);
    this._assignCurrentOutcomeEditView = __bind(this._assignCurrentOutcomeEditView, this);
    this._setPropertyAndPublishActivatedPropertyEvent = __bind(this._setPropertyAndPublishActivatedPropertyEvent, this);
    return OutcomeEditRowView.__super__.constructor.apply(this, arguments);
  }

  OutcomeEditRowView.prototype.tagName = 'tr';

  OutcomeEditRowView.prototype.shortcuts = {
    "tab": "selectNextItem",
    "shift+tab": "selectPrevItem",
    "down": "selectNextItem",
    "up": "selectPrevItem",
    "enter": "saveAndHideEdit"
  };

  OutcomeEditRowView.prototype.bindings = {
    'select[data-property=type]': {
      observe: 'type',
      update: function($el, val) {
        return $el.val(val);
      },
      getVal: function($el) {
        return $el.val();
      }
    },
    'select[data-property=metaType]': {
      observe: 'metaType',
      update: function($el, val) {
        return $el.val(val);
      },
      getVal: function($el) {
        return $el.val();
      }
    },
    'select[data-property=thresholdsType]': {
      observe: 'thresholdsType',
      update: function($el, val) {
        return $el.val(val);
      },
      getVal: function($el) {
        return $el.val();
      }
    },
    'input[name=effectMeasure]': {
      observe: 'effectMeasure',
      update: function($el, val) {
        return $el.val(val);
      },
      getVal: function($el) {
        return $el.val();
      }
    },
    'input[data-property=higherIsBetter]': {
      observe: 'higherIsBetter',
      onGet: function(val) {
        if (val) {
          return 'true';
        } else {
          return 'false';
        }
      },
      onSet: function(val) {
        return val === 'true';
      }
    },
    'input[data-property=thresholdsAutoRange]': {
      observe: 'thresholdsAutoRange',
      update: function($el, val) {
        return $el.prop('checked', Boolean(val));
      },
      getVal: function($el) {
        return $el.prop('checked');
      }
    },
    'input[data-property=utilityValue]': 'utilityValue',
    'input[data-property=denominator]': 'denominator',
    'input[data-property=thresholdT1]': 'thresholdT1',
    'input[data-property=thresholdT2]': 'thresholdT2',
    'input[data-property=thresholdT3]': 'thresholdT3',
    'input[data-property=eventType]': 'eventType',
    'input[data-property=scaleFrom]': 'scaleFrom',
    'input[data-property=scaleTo]': 'scaleTo',
    'input[data-property=scaleType]': 'scaleType',
    'input[data-property=conventionalScaleLowerLimit]': 'conventionalScaleLowerLimit',
    'input[data-property=conventionalScaleUpperLimit]': 'conventionalScaleUpperLimit'
  };

  OutcomeEditRowView.prototype.inputsSelector = 'input, select, textarea';

  OutcomeEditRowView.prototype.initialize = function() {
    OutcomeEditRowView.__super__.initialize.apply(this, arguments);
    this.questionModel = this.options.questionModel;
    this.enable(OutcomeScaleTypes);
    this.delegate('focus', 'select, input', this.setFocusedItemActive);
    this.delegate('click', '.outcome-label-edit button.save', this.saveAndHideEdit);
    this.delegate('click', '.outcome-sort-delete button.delete', this.deleteOutcome);
    this.delegate('click', '.outcome-sort-delete button.sort', this.sortOutcome);
    this.delegate('click', '.outcome-toggleable-editor, .outcome-label-edit', function(e) {
      e.stopPropagation();
      return mediator.setFocus(this);
    });
    this.delegate('contextmenu', 'input, select, label.radio-label', this.showContextMenu);
    this.delegate('change', 'input[name=effectMeasure]', this._toggleCohenEffectSizeLabel);
    this.modelBind('change:type change:metaType', (function(_this) {
      return function() {
        var _ref;
        return (_ref = _this.parentView) != null ? _ref.renderOutcomeRowsForItem(_this.model) : void 0;
      };
    })(this));
    this.modelBind('change:eventType', this.toggleNonEventInput);
    this.modelBind('change:scaleType', this.toggleScaleFields);
    this.modelBind('change:type', this._metaTypeChanged);
    this.modelBind('change:type', this._toggleContOutcomeEffectMeasureSelector);
    this.modelBind('change:type change:effectMeasure', this._toggleCohenEffectSizeLabel);
    this.modelBind('change:type', this._showTimeToEventModalAndSelect);
    this.modelBind('change:thresholdsType change:thresholdsAutoRange', this._toggleThresholdsFields);
    this.modelBind('change:higherIsBetter change:thresholdsAutoRange change:utilityValue change:denominator change:thresholdsType change:type change:effectMeasure', (function(_this) {
      return function() {
        var T1, T2, T3, denominator, effectMeasure, higherIsBetter, outcomeType, utility;
        if (!_this.model.get('thresholdsAutoRange')) {
          return;
        }
        if (_this.model.get('utilityValue') > 1 || _this.model.get('utilityValue') < 0) {
          return;
        }
        utility = Number(_this.model.get('utilityValue')) || 0;
        denominator = Number(_this.model.get('denominator')) || 1000;
        higherIsBetter = _this.model.get('higherIsBetter') || false;
        outcomeType = _this.model.get('type');
        effectMeasure = _this.model.get('effectMeasure');
        T1 = calculateThreshold(utility, 0, denominator, higherIsBetter, outcomeType, effectMeasure);
        T2 = calculateThreshold(utility, 1, denominator, higherIsBetter, outcomeType, effectMeasure);
        T3 = calculateThreshold(utility, 2, denominator, higherIsBetter, outcomeType, effectMeasure);
        return _this.model.set({
          thresholdT1: T1,
          thresholdT2: T2,
          thresholdT3: T3
        });
      };
    })(this));
    this.delegateFootnotesEvents();
    this._stopInputsPropagation = false;
    this.checkTableMode = true;
    this.enable(Shortcuts);
    this.enable(WysiwygFootnotes);
    this.enable(ActiveFootnoteHighlight);
    return this.enable(ReactComponent);
  };

  OutcomeEditRowView.prototype.sortOutcome = function(e) {
    var $target, sortOutcomesView, targetOffset;
    e.stopPropagation();
    sortOutcomesView = new SortOutcomesView({
      parentView: this,
      outcomesView: this.parentView
    });
    this.subview('sortOutcomesView', sortOutcomesView);
    $target = $(e.target);
    targetOffset = $target.offset();
    return sortOutcomesView.show(utils.getEventCoordinates(e));
  };

  OutcomeEditRowView.prototype._setPropertyAndPublishActivatedPropertyEvent = function(property, $target) {
    this.property = property;
    return this.publishEvent('activatedProperty', this.property, $target, this.questionModel, this.model);
  };

  OutcomeEditRowView.prototype.delegateFootnotesEvents = function() {};

  OutcomeEditRowView.prototype.showContextMenu = function(e) {
    mediator.setFocus(this, (function(_this) {
      return function() {
        var $input, $target, contextMenu;
        $target = $(e.target);
        $input = $target.hasClass('radio-label') ? $target.find('input[type=radio]') : $target;
        $input.trigger('focus');
        contextMenu = new ContextMenuView({
          questionModel: _this.questionModel,
          footnotesBindingModel: _this.model,
          property: _this.property,
          propertyView: _this,
          cell: $input,
          abortHandler: function() {
            return mediator.setFocus(_this);
          }
        });
        _this.subview('contextMenu', contextMenu);
        return contextMenu.show(utils.getEventCoordinates(e));
      };
    })(this));
    return false;
  };

  OutcomeEditRowView.prototype._assignCurrentOutcomeEditView = function() {
    return this.parentView.currentOutcomeEditView = this;
  };

  OutcomeEditRowView.prototype._deleteCurrentOutcomeEditView = function() {
    var _ref;
    return (_ref = this.parentView) != null ? _ref.currentOutcomeEditView = null : void 0;
  };

  OutcomeEditRowView.prototype.validateOutcome = function() {
    var $input, checkboxInputs, input, inputs, radioInputs, selectInputs, selectionInputs, textInputs, value, _i, _len;
    textInputs = this.$('input:text');
    radioInputs = this.$('input:radio:checked');
    checkboxInputs = this.$('input:checkbox[data-property]');
    selectInputs = this.$('select[data-property]');
    selectionInputs = this.$('input.selection-input');
    inputs = $.merge(textInputs, radioInputs);
    inputs = $.merge(inputs, checkboxInputs);
    inputs = $.merge(inputs, selectInputs);
    inputs = $.merge(inputs, selectionInputs);
    for (_i = 0, _len = inputs.length; _i < _len; _i++) {
      input = inputs[_i];
      $input = $(input);
      if (!$input.data('property')) {
        continue;
      }
      value = $input.val();
      if ($input.data('property') === 'higherIsBetter') {
        value = value === 'true';
      }
      if ($input.data('property') === 'thresholdsAutoRange') {
        value = $input.prop('checked');
      }
      this.model.set($input.data('property'), value, {
        silent: true
      });
    }
    this.model.validate();
    return this.model.isValid(true);
  };

  OutcomeEditRowView.prototype._checkTableMode = function() {
    if (!this.checkTableMode) {
      return W.resolve(true);
    }
    this.checkTableMode = false;
    return W.promise((function(_this) {
      return function(resolve) {
        if (_this.questionModel.get('$tableMode') === 'narrative' && _this.model.get('type') !== 'narrative') {
          mediator.dialogs.confirm({
            title: $.t('es:outcome.mode.change_to_regular'),
            message: $.t('es:outcome.mode.change_to_regular_desc'),
            yesClass: 'danger',
            buttons: [
              {
                'data-role': 'no',
                text: $.t('es:outcome.mode.keep_narrative_mode')
              }, {
                'data-role': 'yes',
                text: $.t('es:outcome.mode.change_to_regular')
              }
            ]
          }, function(change) {
            if (change) {
              _this.questionModel.set('$tableMode', 'regular', {
                auto: true
              });
            } else {
              _this.model.set('type', 'narrative');
            }
            return resolve(change);
          });
        } else if (_this.questionModel.get('$tableMode') !== 'narrative' && _this.questionModel.areAllOutcomesNarrative()) {
          _this.questionModel.set('$tableMode', 'narrative', {
            auto: true
          });
          resolve(true);
        } else {
          resolve(true);
        }
        return _this.checkTableMode = true;
      };
    })(this));
  };

  OutcomeEditRowView.prototype._isValid = function() {
    if (!this.validateOutcome()) {
      return W.resolve(false);
    }
    return this._checkTableMode();
  };

  OutcomeEditRowView.prototype.applyChangesAndClose = function() {
    this.model.save();
    this._deleteCurrentOutcomeEditView();
    return this.hideEdit();
  };

  OutcomeEditRowView.prototype.saveAndHideEdit = function(e) {
    if (e != null) {
      e.stopPropagation();
    }
    if (e != null) {
      e.preventDefault();
    }
    return this._isValid().then((function(_this) {
      return function(valid) {
        if (valid) {
          return _this.applyChangesAndClose();
        }
      };
    })(this));
  };

  OutcomeEditRowView.prototype.beforeFocusLost = function(deferred, focusTo) {
    if (this.changingFocusToSubview(focusTo)) {
      return deferred.resolve();
    }
    return this._isValid().then(function(valid) {
      if (valid) {
        return deferred.resolve();
      } else {
        deferred.reject();
        return false;
      }
    });
  };

  OutcomeEditRowView.prototype.onFocusLost = function(focusTo) {
    if (this.changingFocusToSubview(focusTo)) {
      return;
    }
    return this.applyChangesAndClose();
  };

  OutcomeEditRowView.prototype.hideEdit = function() {
    this.publishEvent('deactivatedProperty');
    if (this.disposed) {
      return;
    }
    return this.$('.outcome-toggleable-editor').slideUp((function(_this) {
      return function() {
        var _ref, _ref1, _ref2;
        if ((_ref = _this.parentView) != null) {
          _ref.renderItemViews(_this.model);
        }
        if ((_ref1 = _this.parentView) != null) {
          _ref1.trigger('!fixLayout');
        }
        if ((_ref2 = _this.parentView) != null ? _ref2.currentOutcomeEditView : void 0) {
          return typeof _this.hideEditCallback === "function" ? _this.hideEditCallback() : void 0;
        } else {
          return mediator.setFocus(function() {
            return typeof _this.hideEditCallback === "function" ? _this.hideEditCallback() : void 0;
          });
        }
      };
    })(this));
  };

  OutcomeEditRowView.prototype.render = function() {
    this.bindValidationTooltips();
    return OutcomeEditRowView.__super__.render.apply(this, arguments);
  };

  OutcomeEditRowView.prototype.afterRender = function() {
    var _ref;
    OutcomeEditRowView.__super__.afterRender.apply(this, arguments);
    this.inputs = this.$el.find(this.inputsSelector);
    this._metaTypeChanged();
    this._toggleContOutcomeEffectMeasureSelector();
    this._toggleCohenEffectSizeLabel();
    this._toggleThresholdsFields();
    this.toggleScaleFields();
    this.selectionSize = this.inputs.length;
    this.stickit();
    this.stickFootnotes(this.options.questionModel);
    this.stickHighlightFootnotes();
    if (this.options.viewTypeName.toLowerCase().indexOf('printout' !== -1)) {
      return;
    }
    if (mediator.services.switches.isOn('qualityIndicators')) {
      return this.renderSimpleComponent(QualityIndicatorsInput, {
        outcome: this.model.toJSON()
      }, (_ref = this.$('.quality-indicators-input-container')) != null ? _ref.get(0) : void 0);
    }
  };

  OutcomeEditRowView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.inputs = null;
    this.unstickit();
    this.unstickFootnotes();
    this.unstickHighlightFootnotes();
    this.unmountComponent();
    return OutcomeEditRowView.__super__.dispose.apply(this, arguments);
  };

  OutcomeEditRowView.prototype.deleteOutcome = function(e) {
    var questionModel, revManWebDeletedOutcomeIds, _ref, _ref1;
    e.preventDefault();
    questionModel = this.options.questionModel;
    this.checkTableMode = false;
    this.model.collection.store();
    if (questionModel.get('revManWebReviewId') != null) {
      revManWebDeletedOutcomeIds = (_ref = questionModel.get('revManWebDeletedOutcomeIds')) != null ? _ref : [];
      revManWebDeletedOutcomeIds.push(this.model.id);
      questionModel.save('revManWebDeletedOutcomeIds', revManWebDeletedOutcomeIds);
    }
    this.model.destroy();
    return (_ref1 = this.parentView) != null ? _ref1.trigger('!fixLayout') : void 0;
  };

  OutcomeEditRowView.prototype.setFocusedItemActive = function(e) {
    this.setSelectionIndex(this.inputs.index($(e.target)));
    return true;
  };

  OutcomeEditRowView.prototype.setSelectionIndex = function(idx) {
    var _ref;
    this.selectionIndex = idx;
    return (_ref = this.inputs[this.selectionIndex]) != null ? _ref.focus() : void 0;
  };

  OutcomeEditRowView.prototype.showThresholdFeature = function() {
    return mediator.services.switches.isOn('thresholdFeature');
  };

  OutcomeEditRowView.prototype.getTemplateData = function() {
    var data;
    data = OutcomeEditRowView.__super__.getTemplateData.apply(this, arguments);
    data.cid = this.model.cid;
    data.isCaseControl = this.model.isCaseControl();
    data.viewTypeName = this.options.viewTypeName;
    data.colspan = this.options.colspan;
    data.scaleType = this.model.get('scaleType');
    data.thresholdFeature = this.showThresholdFeature();
    data.higherIsBetter = this.model.higherIsBetter();
    return data;
  };

  OutcomeEditRowView.prototype.selectNextItem = function(e) {
    this.setSelectionIndex((this.selectionIndex + 1) % this.selectionSize);
    return false;
  };

  OutcomeEditRowView.prototype.selectPrevItem = function(e) {
    var idx;
    idx = this.selectionIndex === 0 ? this.selectionSize - 1 : (this.selectionIndex - 1) % this.selectionSize;
    this.setSelectionIndex(idx);
    return false;
  };

  OutcomeEditRowView.prototype.toggleNonEventInput = function() {
    if (this.model.get('eventType') === 'non_event') {
      return this.$('input[data-property="nonEvent"]').show();
    } else {
      return this.$('input[data-property="nonEvent"]').hide();
    }
  };

  OutcomeEditRowView.prototype._showTimeToEventModalAndSelect = function() {
    if (this.model.get('type') !== 'time_to_event') {
      return;
    }
    if (this.model.get('type') === 'time_to_event') {
      this.$('div.non-event').show();
    } else {
      this.$('div.non-event').hide();
    }
    return this.subview('timeToEventModal', new TimeToEventModal({
      model: this.model,
      parentView: this
    }));
  };

  OutcomeEditRowView.prototype._toggleThresholdsFields = function() {
    var $thresholdInputs, $thresholdRows, $thresholdT1, $thresholdValueInputs;
    $thresholdInputs = this.$('.thresholds-options');
    $thresholdRows = this.$('.thresholds-options .thresholds');
    $thresholdT1 = this.$('.thresholds-options .threshold-T1');
    $thresholdValueInputs = this.$('.thresholds-options input[data-property="thresholdT1"], .thresholds-options input[data-property="thresholdT2"], .thresholds-options input[data-property="thresholdT3"]');
    $thresholdValueInputs.prop('disabled', Boolean(this.model.get('thresholdsAutoRange')));
    if (this.model.get('thresholdsType') === 'MinimallyImportantDifferences') {
      $thresholdInputs.show();
      $thresholdRows.hide();
      return $thresholdT1.show();
    } else if (this.model.get('thresholdsType') === 'MagnitudeOfEffect') {
      $thresholdInputs.show();
      return $thresholdRows.show();
    } else {
      return $thresholdInputs.hide();
    }
  };

  OutcomeEditRowView.prototype._metaTypeChanged = function() {
    var $metaTypeSelect, disableValues, _ref;
    $metaTypeSelect = this.$('select[data-property="metaType"]');
    if (this.model.get('type') === 'narrative') {
      disableValues = ['POOLED', 'SINGLE_STUDY', 'RANGE_OF_EFFECTS'];
      if (_ref = this.model.get('metaType'), __indexOf.call(disableValues, _ref) >= 0) {
        this.model.set('metaType', 'NOT_POOLED');
      }
      if ($metaTypeSelect.length) {
        _($metaTypeSelect.find('option')).chain().filter(function(item) {
          var _ref1;
          return _ref1 = item.value, __indexOf.call(disableValues, _ref1) >= 0;
        }).each(function(item) {
          return $(item).prop('disabled', true);
        });
      } else {
        _(this.$('input[data-property="metaType"]')).chain().filter(function(item) {
          var _ref1;
          return _ref1 = item.value, __indexOf.call(disableValues, _ref1) >= 0;
        }).each(function(item) {
          return $(item).prop('disabled', true);
        });
      }
    } else {
      if ($metaTypeSelect.length) {
        $metaTypeSelect.find('option').prop('disabled', false);
      } else {
        this.$('input[data-property="metaType"]').prop('disabled', false);
      }
    }
    if (this.model.get('type') === 'cont') {
      this.$('.cont-outcome-scores-scale').show();
    } else {
      this.$('.cont-outcome-scores-scale').hide();
    }
    if (this.model.get('type') === 'time_to_event') {
      return this.$('.non-event').show();
    } else {
      return this.$('.non-event').hide();
    }
  };

  OutcomeEditRowView.prototype._toggleContOutcomeEffectMeasureSelector = function() {
    var $contOutcomeEffectMeasure;
    $contOutcomeEffectMeasure = this.$('.cont-outcome-effect-measure');
    if (!$contOutcomeEffectMeasure.length) {
      return;
    }
    if (this.model.get('type') === 'cont') {
      return $contOutcomeEffectMeasure.show();
    } else {
      return $contOutcomeEffectMeasure.hide();
    }
  };

  OutcomeEditRowView.prototype._toggleCohenEffectSizeLabel = function() {
    var $cohenEffectSizeLabel, selectedEffectMeasure, shouldShowCohenLabel, _ref;
    $cohenEffectSizeLabel = this.$('.cohen-effect-size-label');
    if (!$cohenEffectSizeLabel.length) {
      return;
    }
    selectedEffectMeasure = (_ref = this.$('input[name="effectMeasure"]').val()) != null ? _ref : this.model.get('effectMeasure');
    shouldShowCohenLabel = this.model.get('type') === 'cont' && selectedEffectMeasure === 'SMD';
    if (shouldShowCohenLabel) {
      return $cohenEffectSizeLabel.show();
    } else {
      return $cohenEffectSizeLabel.hide();
    }
  };

  return OutcomeEditRowView;

})(View);
